/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { humanize } from "uno-js";
// import { data } from "./config/profile-data"

import { GET_APPLICATION_FEE_TABLE ,EDIT_APP_FEE} from "../pages/ApplicationFee/graphql"

import { tableData } from "./test-data/application-fee-table-data"

import { toast } from "react-hot-toast"

const MODULE_NAME = "ApplicationService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class ApplicationService {
    private static instance: ApplicationService;
    private vapp: VApplication;
    private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): ApplicationService {
        if (!ApplicationService.instance) {
            ApplicationService.instance = new ApplicationService(props);
        }
        return ApplicationService.instance;
    }



    async getApplication(limit: number, skip: number, filter: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");

        try {
            if (client) {
                const res = await client.query({
                    query: GET_APPLICATION_FEE_TABLE,
                    variables: {
                        criteria: {
                            ...filter,
                            fee:parseInt(filter?.fee),
                            processTime:parseInt(filter?.processTime)
                        },
                        skip: skip,
                        limit: limit
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getApplication fee table: ", res?.data);
                if (res) {
                    return res?.data?.getProcessTable
                }           
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }

    }

    
    async editApplicationFee(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `EDIT Application Fee  data in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: EDIT_APP_FEE,
                    variables: data,
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "EDIT Profile: ", res);
                if (res) {
                    return res
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }


}
